import { render, staticRenderFns } from "./Test2.vue?vue&type=template&id=3857aaf7&scoped=true&"
import script from "./Test2.vue?vue&type=script&lang=js&"
export * from "./Test2.vue?vue&type=script&lang=js&"
import style0 from "./Test2.vue?vue&type=style&index=0&id=3857aaf7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3857aaf7",
  null
  
)

export default component.exports